/* eslint-disable camelcase */
import { CircularProgress, makeStyles } from '@material-ui/core';
import React, { CSSProperties } from 'react';
import { EntityViewConfig, FetchEntityTimeSpanDataParams, FetchEntityTimeRangeDataParams, EntityUIComponentProps } from '.';
import { RitzComponentsCollection } from '../../utils/ritzComponentsCollection';
import { EntityDetailsGenericLayoutContainer } from './EntityDetailsGenericLayoutContainer';


const useStyle = makeStyles(() => {
    return {
        root: {
            display      : 'flex',
            flexDirection: 'column',
        },

    };
}, { name: 'EntityDetailsContent', index: 1 });



export interface EntityDetailsContentProps {
    readonly className?: string | undefined;
    readonly style?: CSSProperties | undefined;
    readonly projectId: number;

    readonly entityId: string;
    readonly viewConfig: EntityViewConfig;

    // The params for fetching data. Most of these params are from user inputs from the Entity control bar. These will not be used in
    // this component. They will be forwarded to each individual EntityUIComponent to do what they need to do with these params
    readonly fetchDataParams?: FetchEntityTimeSpanDataParams | FetchEntityTimeRangeDataParams | undefined;
    readonly onShowEntityDetails: EntityUIComponentProps['onShowEntityDetails'];
    readonly onShowEntityPreview: EntityUIComponentProps['onShowEntityPreview'];
}


/**
 * This component display info for 1 entity. For now it will only display the entity name and ID but this component will
 * be displaying entity data e.g charts, dashboard, etc...
 */
export const EntityDetailsContent: React.FC<EntityDetailsContentProps> = (props: EntityDetailsContentProps) => {

    const classes = useStyle();

    return (
        <>
            { props.viewConfig ? (
                <div className={classes.root}>
                    {/*
                        For entities that use generic layout/components placement that can be configured using the EntityDetailsPageLayout
                        structure will use this EntityDetailsGenericLayoutContainer. For entities that require very specific layout, we can
                        create separate react component for them.
                    */}
                    <EntityDetailsGenericLayoutContainer
                        projectId={props.projectId}
                        entityId={props.entityId}
                        pageLayout={props.viewConfig.layout}
                        componentsPlacement={props.viewConfig.componentsPlacement}
                        onShowEntityDetails={props.onShowEntityDetails}
                        onShowEntityPreview={props.onShowEntityPreview}
                        fetchDataParams={props.fetchDataParams}
                    />
                </div>
            ) : (
                <CircularProgress />
            )}
        </>
    );
};


// Register this component with the RitzComponentsCollection so that it can be used with the Ritz UI customization system
RitzComponentsCollection.getInstance().registerComponent('EntityDetailsContent', EntityDetailsContent);
